import { groupBy } from 'lodash';
import { DateTime } from 'luxon';
import { WorkersAvailabilityPaginated } from 'api/services/availability/availability-service.schema';
import { dayAccessors, DayColumnAccessors } from '../../calendar/calendar-grid.types';
import { AvailabilityParsed, AvailabilityParsedItem } from '../availability-calendar.types';

const toLocalDateTime = (iso: string) => DateTime.fromISO(iso).toLocal();

export const mapAvailabilityResponseToParsedGridDataMonthView = (
  workerAvailabilities: WorkersAvailabilityPaginated['items'],
  selectedDate: DateTime
): AvailabilityParsed<DayColumnAccessors>[] => {
  const viewedMonth = selectedDate.toLocal();
  return workerAvailabilities.map((worker) => {
    const workerAvailabilityItem: AvailabilityParsedItem[] = worker.availability
      .filter((availability) =>
        toLocalDateTime(availability.utcStartDateTime).hasSame(viewedMonth, 'month')
      )
      .map((availability) => ({
        segmentId: availability.id,
        type: availability.type,
        utcStartDateTime: availability.utcStartDateTime,
        utcEndDateTime: availability.utcEndDateTime,
        workName: availability.workName,
        companyName: availability.companyName,
        workerForPopover: {
          workerId: worker.workerId,
          firstName: worker.firstName,
          infix: worker.infix,
          lastName: worker.lastName,
          profilePictureUrl: worker.profilePictureUrl,
          email: worker.email,
          partnerName: worker.partnerName,
          lenderCompanyName: worker.lenderCompanyName,
          employmentType: worker.employmentType,
        },
      }));
    const groupedByDay = groupBy<AvailabilityParsedItem>(
      workerAvailabilityItem,
      (item) => `DAY_${toLocalDateTime(item.utcStartDateTime).day.toString()}`
    );
    const groupedAvailability: Record<DayColumnAccessors, AvailabilityParsedItem[] | undefined> =
      dayAccessors.reduce(
        (
          acc: Record<DayColumnAccessors, AvailabilityParsedItem[] | undefined>,
          day: DayColumnAccessors
        ) => {
          acc[day] = groupedByDay[day];
          return acc;
        },
        {} as Record<DayColumnAccessors, AvailabilityParsedItem[] | undefined>
      );
    const parsedItem: AvailabilityParsed<DayColumnAccessors> = {
      worker: {
        workerId: worker.workerId,
        firstName: worker.firstName,
        infix: worker.infix,
        lastName: worker.lastName,
        profilePictureUrl: worker.profilePictureUrl,
        email: worker.email,
        partnerName: worker.partnerName,
        lenderCompanyName: worker.lenderCompanyName,
        employmentType: worker.employmentType,
      },
      ...groupedAvailability,
    };
    return parsedItem;
  });
};
